"use client";
import React from "react";
import {
  Box,
  Divider,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  VStack,
  Stack,
  HStack,
  SimpleGrid,
  Center,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {MICROSOFT_MANAGED_BUNDLES} from "./constants";
import {FaMicrosoft} from "@onemind-services-llc/react-icons-ng/fa";

export const DesktopView = () => {
  return (
    <TableContainer>
      <Table
        variant="striped"
        border="2px solid rgb(237,242,247)"
        width="100%"
        sx={{
          th: {textAlign: "center"},
          td: {textAlign: "center"},
        }}
      >
        <Thead>
          <Tr>
            <Th>Minimum User Tier</Th>
            <Th>Per User Monthly Price</Th>
            <Th>Microsoft License</Th>
            <Th>Support Hours/Month</Th>
          </Tr>
        </Thead>
        <Tbody>
          {MICROSOFT_MANAGED_BUNDLES.map((bundle, index) => (
            <Tr key={index}>
              <Td>{bundle.minUserTier}</Td>
              <Td>
                <Text fontWeight="700" color="blue.600" fontSize={"18px !important"}>
                  {bundle.pricePerUser}
                </Text>
              </Td>
              <Td>{bundle.license}</Td>
              <Td>{bundle.supportHours}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export const MobileView = () => {
  return (
    <SimpleGrid columns={{base: 1, sm: 2}} spacing={6}>
      {MICROSOFT_MANAGED_BUNDLES.map((bundle, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          spacing={4}
          w="100%"
          p={4}
          bg="white"
        >
          <HStack spacing={3} align="center" w="full">
            <Box
              h="2.5rem"
              w="2.5rem"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="md"
              bg="gray.50"
            >
              <FaMicrosoft color="#F25022" size="1.5rem" />
            </Box>
            <Text fontWeight="bold" fontSize="lg">
              {bundle.license}
            </Text>
          </HStack>

          <Divider borderColor="gray.200" />

          <Stack spacing={2} w="full">
            <Text fontSize="sm" color="gray.600">
              Minimum User Tier
            </Text>
            <Text fontWeight="medium">{bundle.minUserTier}</Text>
          </Stack>

          <Stack spacing={2} w="full">
            <Text fontSize="sm" color="gray.600">
              Per User Monthly Price
            </Text>
            <Text fontWeight="bold" fontSize="lg" color="blue.600">
              {bundle.pricePerUser}
            </Text>
          </Stack>

          <Stack spacing={2} w="full">
            <Text fontSize="sm" color="gray.600">
              Support Hours/Month
            </Text>
            <Text fontWeight="medium">{bundle.supportHours}</Text>
          </Stack>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const MicrosoftServicesTable = ({showHeading = true}: {showHeading?: boolean}) => {
  const HeadingVariant = useSectionHeadingVariant();

  return (
    <Box id="microsoft-services-bundles">
      {showHeading && (
        <Heading variant={HeadingVariant} textAlign="center" mb={8}>
          Managed Services Microsoft Bundles
        </Heading>
      )}
      <Center display={{md: "none"}} w="full">
        <MobileView />
      </Center>

      <Box display={{base: "none", md: "block"}}>
        <DesktopView />
      </Box>
    </Box>
  );
};

export default MicrosoftServicesTable;
